<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="beca" titulo="Beca / articulos financieros" [dato]="dato"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">

  <div class="column is-2 is-hidden-mobile menu-izquierda">

    <!-- Menu izquierda del modulo enviroment" -->
    <app-sistema-menu-aside></app-sistema-menu-aside>
  </div>
  <div class="column" style="padding:0px;">
    <div style="background: #FFF; border-radius: 1em; ">

      <!-- inicio formulario -->
      <form name="form" novalidate [formGroup]="dato" (ngSubmit)="ctrl.enviar()">
        <section class="hero is-primary">
          <div class="hero-body">

            <!-- Opciones  -->
            <app-formulario-opciones [ctrl]="ctrl" [id]="ctrl.dato.id"></app-formulario-opciones>
          </div>
        </section>
        <div class="is-fullwidth has-text-centered" *ngIf="!ctrl.datosCargados">
          <br>
          <span class="tag is-primary is-large ">
            <span class="icon">
              <i class="icon-worldwide fa-spin"></i>
            </span> &nbsp;
            <span>Cargando...</span>
          </span>
        </div>

        <section class="section" style="padding: 1rem !important; overflow:auto; height: 85.8vh;" >
          <a id="catalogos" (click)="ctrl.cargarCatalogo('carreras', 'carrera', 'pintar_tabla'); ctrl.cargarCatalogo('articulos', 'servicio'); "></a>
          <a id="pintar_tabla" (click)="pintar_tabla(ctrl.carreras, ctrl.dato.controls.becas_detalles); "></a>
          <div class="field">
            <label class="label">Nombre:</label>
            <p class="control has-icons-left has-icons-right">
              <input class="input" autofocus type="text" [ngClass]="{'is-danger': ctrl.dato.get('nombre').hasError('required') }"
                placeholder="Nombre" formControlName="nombre">
              <span class="icon is-small is-right" *ngIf="ctrl.dato.get('nombre').hasError('required') ">
                <i class="fa fa-warning"></i>
              </span>
              <span class="help is-danger" *ngIf="ctrl.dato.get('nombre').hasError('required') ">Este campo es
                requerido.</span>
            </p>
          </div>
          <div class="field">
            <label class="label">Descripción:</label>
            <p class="control has-icons-left has-icons-right">
              <input class="input" autofocus type="text" [ngClass]="{'is-danger': ctrl.dato.get('descripcion').hasError('required') }"
                placeholder="Descripción" formControlName="descripcion">
              <span class="icon is-small is-right" *ngIf="ctrl.dato.get('descripcion').hasError('required') ">
                <i class="fa fa-warning"></i>
              </span>
              <span class="help is-danger" *ngIf="ctrl.dato.get('descripcion').hasError('required') ">Este campo es
                requerido.</span>
            </p>
          </div>
          <div class="field is-grouped is-fullwidth">

            <div class="field" style=" width: 50%; ">
              <br><br>
              <div class="control b-checkbox is-info ">

                <input id="porcentaje_si" type="radio" formControlName="es_porcentaje" [value]="true" (change)="toggleCambiarPorcentaje(1)"
                  [checked]="ctrl.dato.get('es_porcentaje').value">
                <label for="porcentaje_si">
                  ¿Se utiliza porcentaje?
                </label>

                <input id="porcentaje_no" type="radio" formControlName="es_porcentaje" [value]="false" (change)="toggleCambiarPorcentaje(0)"
                  [checked]="!ctrl.dato.get('es_porcentaje').value">
                <label for="porcentaje_no">
                  ¿Se utiliza cantidad?
                </label>
              </div>

            </div>


            <div class="field" style=" width: 27.77%; ">
              <br><br>
              <div class="b-checkbox is-info">
                <input id="requiere_promedio" class="styled" type="checkbox" formControlName="requiere_promedio"
                  (click)="toggleCambiarRequierePromedio()">
                <label for="requiere_promedio">
                  ¿Se requiere un promedio acádemico?
                </label>
              </div>
            </div>

            <div class="field" style=" width: 33.33%; ">
              <label class="label">Promedio requerido:</label>
              <p class="control has-icons-left has-icons-right">
                <input class="input" type="number" min="5" placeholder="Promedio requerido" formControlName="promedio_requerido"
                  [ngClass]="{'is-danger': ctrl.dato.get('promedio_requerido').hasError('required') }">
                <span class="icon is-small is-right" *ngIf="ctrl.dato.get('promedio_requerido').hasError('required') ">
                  <i class="fa fa-warning"></i>
                </span>
                <span class="help is-danger" *ngIf="ctrl.dato.get('promedio_requerido').hasError('required') ">Este
                  campo es requerido.</span>
              </p>
            </div>
          </div>

          <section class="hero" style="background:gainsboro">
            <div class="hero-body">
              <p class="title">
                <span class="icon is-medium ng-star-inserted">
                  <i class="fa fa-calendar"></i>
                </span>
                Programación de beca
              </p>
              <p class="subtitle">
                Seleccione {{ctrl.dato.get('es_porcentaje').value ? 'el porcentaje ' : 'la cantidad '}} para cada rubro
              </p>

            </div>
          </section>
          <table class="table is-striped is-fullwidth" formArrayName="becas_detalles">
            <thead>
              <tr>
                <th>
                  <abbr>Carrera</abbr>
                </th>
                <th *ngFor="let c of tipos" style="width: 15%;">{{c.nombre}}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of ctrl.dato.controls.becas_detalles.controls; let i=index" [formGroupName]="i">
                <td>
                  <abbr>{{item.value.carreras_nombre}}</abbr>
                </td>
                <td colspan="4">
                  <table class="table is-fullwidth" style="margin:0px; background: transparent;">
                    <tr formArrayName="articulos">
                      <td *ngFor="let c of item.controls.articulos.controls; let x = index" style="padding:0px; width: 15%;"
                        [formGroupName]="x">
                        <input style="width:88%" [ngClass]="{'is-danger': c.get('importe').hasError('required') }" id="importe{{i}}{{x}}"
                          name="importe{{i}}{{x}}" class="input" type="number" placeholder="importe" [max]="max"
                          formControlName="importe">
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>


        </section>

      </form>
    </div>
  </div>
</div>
